import { Routes } from '@angular/router';
import {
	LOGIN_PATH,
	REGISTRATION_PATH,
	REGISTRATION_SHOPPER_DETAILS_PATH,
	REGISTRATION_SUCCESSFUL_PATH,
} from '@woolworthsnz/shop';
import { AuthPageGuard, ShopperGuard } from './guards';
import { AuthenticationPage } from './pages';

export const routes: Routes = [
	{
		path: '',
		runGuardsAndResolvers: 'always',
		component: AuthenticationPage,
		children: [
			{
				path: LOGIN_PATH,
				canActivate: [AuthPageGuard],
				runGuardsAndResolvers: 'always',
				loadComponent: () => import('./pages').then((c) => c.SigninPage),
				data: {
					heading: 'Sign in for online shopping',
				},
			},
			{
				path: REGISTRATION_PATH,
				canActivate: [AuthPageGuard],
				runGuardsAndResolvers: 'always',
				loadComponent: () => import('./pages').then((c) => c.RegisterPage),
				data: {
					heading: 'Register for online shopping',
					hideSubHeaderWhenEmbedded: true,
					hideFulfilmentBarWhenEmbedded: true,
					hideEmbeddedNavWhenEmbedded: true,
				},
			}
		],
	},
	{
		path: REGISTRATION_SHOPPER_DETAILS_PATH,
		loadComponent: () => import('./pages').then((c) => c.ShopperDetailsPage),
		data: {
			heading: 'Register for online shopping',
			hideSubHeaderWhenEmbedded: true,
			hideFulfilmentBarWhenEmbedded: true,
			hideEmbeddedNavWhenEmbedded: true,
		},
	},
	{
		path: REGISTRATION_SUCCESSFUL_PATH,
		loadComponent: () => import('./pages').then((c) => c.WelcomePage),
		canActivate: [ShopperGuard],
	},
];
